import { AvatarGroup } from "@/components/Avatar/AvatarGroup";
import { AirlineAvatar } from "@/features/flights/components/AirlineAvatar";
import type { Airline } from "@/features/flights/types/types";

type Props = {
  airlines: Airline[];
};

export function AirlineAvatarGroup({ airlines }: Props) {
  return (
    <AvatarGroup>
      {airlines.map((airline) => (
        <AirlineAvatar key={airline.name} airline={airline} size="medium" />
      ))}
    </AvatarGroup>
  );
}
